const root = 'importList'
const pageHeader = `${root}-pageHeader`
const productRemovalModal = `${root}-productRemovalModal`
const batchActionModal = `${root}-batchActionModal`

export const TestId = {
  root,
  pageHeader,
  pageHeaderTitle: `${pageHeader}-title`,
  productRemovalModal,
  confirmProductRemoveButton: `${productRemovalModal}-confirmButton`,
  selectAllButtonBase: root,
  selectAllButton: `${root}-selectAllButton`,
  selectAllButtonSelectAllOnPage: `${root}-selectAllButton-selectPage`,
  selectAllButtonSelectAll: `${root}-selectAllButton-selectAll`,
  batchActionModal,
  batchActionModalPrimaryButton: `${batchActionModal}-primaryButton`,
  batchActionModalCloseButton: `${batchActionModal}-closeButton`,
}
